import { CreateIconArguments } from '##/icons/Icon/helpers';

import IconToolsHoldMidSizeS from './IconToolsHoldMid_size_s';

const props: CreateIconArguments = {
  l: IconToolsHoldMidSizeS,
  m: IconToolsHoldMidSizeS,
  s: IconToolsHoldMidSizeS,
  xs: IconToolsHoldMidSizeS,
  name: 'IconToolsHoldMid',
  renderType: { l: 'use', m: 'use', s: 'use', xs: 'use' },
  color: 'multiple',
};

export default props;
